import React from 'react';
import './nomina.css';

// Textos de DOCUMENTO_ENVIADO en Gestión de Nómina (también los usa la búsqueda de la tabla)
export const ESTADOS_NOMINA = {
  "0": "En Proceso",
  "1": "Pendiente DIAN",
  "2": "Exitoso DIAN",
  "3": "Error DIAN",
  "4": "Correo Enviado",
  "5": "Por Aprobación"
};

const StatusBadge = ({ estado }) => (
  <span className={`nom-pill nom-estado-${estado}`}>{ESTADOS_NOMINA[estado] || "Desconocido"}</span>
);

export default StatusBadge;



// WEBPACK FOOTER //
// ./src/components/nomina/components/StatusBadge.jsx